// extracted by mini-css-extract-plugin
module.exports = {"swiper":"VerLayout_swiper_aqcnz","swiper_item":"VerLayout_swiper_item_1RSa3"};